import "./LeaseBusiness.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LeasingBenefits from "./sections/LeasingBenefits";
import LeasePackages from "./sections/LeasePackages";
import CorporateInquiry from "./sections/CorporateInquiry";
import GlobalFooter from "@/reusable_sections/Footer";
export default function LeaseBusinessPage() {
  return <div>
      <MainNavigation />
      <LeasingBenefits />
      <LeasePackages />
      <CorporateInquiry />
      <GlobalFooter />
    </div>;
}